import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AnuncioWizard } from "@/components/AnuncioWizard";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Sparkles, Pencil, LayoutGrid, Eye } from "lucide-react";

export default function CriarAnuncio() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [publishedId, setPublishedId] = useState(null);

  const submit = async (payload) => {
    setSaving(true);
    try {
      const { data } = await api.post("/listings", payload);
      setPublishedId(data.id);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  if (publishedId) {
    return (
      <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-16" data-testid="publish-success">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="max-w-lg w-full text-center">
          <div className="w-20 h-20 rounded-full bg-emerald-500/10 flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-11 h-11 text-emerald-500" strokeWidth={1.5} />
          </div>
          <span className="inline-flex items-center gap-1 text-xs font-700 bg-blaze/10 text-blaze px-3 py-1 rounded-sm mb-4"><Sparkles className="w-3.5 h-3.5" /> Publicado 100% grátis</span>
          <h1 className="font-heading font-800 text-3xl md:text-4xl tracking-tight mb-3">Seu anúncio está no ar!</h1>
          <p className="text-muted-foreground mb-8">
            Sem taxas, sem pegadinhas. E o melhor: você pode <b className="text-obsidian">editar tudo quando quiser</b>, sempre que precisar.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={() => navigate(`/anuncio/${publishedId}`)} className="h-12 px-6 bg-obsidian hover:bg-blaze text-white font-700 rounded-sm" data-testid="success-view-btn">
              <Eye className="w-4 h-4 mr-2" /> Ver meu anúncio
            </Button>
            <Button variant="outline" onClick={() => navigate(`/editar/${publishedId}`)} className="h-12 px-6 rounded-sm font-700" data-testid="success-edit-btn">
              <Pencil className="w-4 h-4 mr-2" /> Editar
            </Button>
            <Button variant="ghost" onClick={() => navigate("/painel", { state: { newId: publishedId } })} className="h-12 px-6 rounded-sm font-700" data-testid="success-panel-btn">
              <LayoutGrid className="w-4 h-4 mr-2" /> Meus anúncios
            </Button>
          </div>
        </motion.div>
      </div>
    );
  }

  return (
    <div data-testid="criar-page">
      <AnuncioWizard onSubmit={submit} submitting={saving} />
    </div>
  );
}
